define('controller/people/internal.association.list.controller',['require','exports','module','fukit/fukit','view/people/internal.associations.list.page.view','model/association.model','model/person.model','backbone.radio','fukit/fukit'],function(require, exports, module) {
  //prettier-ignore
  var BaseController               = require('fukit/fukit').BaseController,
      InternalAssociationsListView = require('view/people/internal.associations.list.page.view'),
      AssociationsModel            = require('model/association.model'),
      PersonModel                  = require('model/person.model'),
      Radio                        = require('backbone.radio'),
      ROLES                        = require('fukit/fukit').Roles;

  var InternalAssociationsListController = BaseController.extend({
    radioRequests: {
      'controllers InternalAssociationsListController': '@constructor',
    },

    pageView: InternalAssociationsListView,

    // stateConfiguration: {
    //   defaults: {
    //     roles: ROLES.GLOBALACCESSROLES
    //   }
    // },

    resources: {
      person: {
        model: PersonModel,
      },
      currentPersonCollection: {
        collection: PersonModel.Collection,
      },
      associations: {
        collection: AssociationsModel.Collection,
      },
    },

    onStart: function() {
      var userPrincipalModel = Radio.request('AppKit.resourceService', 'resource', 'userPrincipalModel');
      var personModel = this.getResource('person');
      var currentPersonCollection = this.getResource('currentPersonCollection');
      var associations = this.getResource('associations');

      if (userPrincipalModel && userPrincipalModel.id) {
        currentPersonCollection.filters.addFilterWithField({ name: 'userAccountId' }).equals(userPrincipalModel.id);
        currentPersonCollection
          .fetch()
          .promise()
          .bind(this)
          .done(function() {
            if (currentPersonCollection.length !== 0) {
              personModel.set(currentPersonCollection.models[0].toJSON());
              if (personModel.getLink('affiliations')) {
                associations.url = personModel.getLink('affiliations').get('href');
                associations.fetch();
              }
            }
          });
      }
    },
  });

  module.exports = InternalAssociationsListController;
});

